import {
    SET_ALARM_PIPELINE,
    SET_CAMERA_POSITION_TYPES,
    SET_CHANNELS,
    SET_DEVICE_COMMAND_STATES,
    SET_DEVICE_COMMAND_TYPES,
    SET_DEVICE_DATA_TO_CAPTURE,
    SET_DEVICE_HEALTH_CHECK_TYPES,
    SET_DEVICE_MODELS,
    SET_DEVICE_PROTOCOLS,
    SET_EVENT_CATEGORIES,
    SET_EVENT_CLASSIFICATIONS,
    SET_EVENT_TYPES,
    SET_FUEL_TYPES,
    SET_LANGUAGES,
    SET_LICENSES,
    SET_ROLES,
    SET_SPEED_UNIT_TYPES,
    SET_THRESHOLD_LEVELS,
    SET_TIMELINE_BLOCK_STATUSES,
    SET_VEHICLE_TYPES,
    SET_VIDEO_STREAM_QUALITY_TYPES,
    SET_TIME_ZONES,
    SET_BRAND_IMAGE_TYPE
} from './mutations';

const setDictionaries = ({ commit }, payload) => {
    commit(SET_DEVICE_MODELS, payload.DeviceModels)
    commit(SET_DEVICE_PROTOCOLS, payload.DeviceProtocol)
    commit(SET_DEVICE_COMMAND_TYPES, payload.DeviceCommandType)
    commit(SET_DEVICE_COMMAND_STATES, payload.DeviceCommandState)
    commit(SET_DEVICE_DATA_TO_CAPTURE, payload.DeviceDataToCapture)
    commit(SET_CHANNELS, payload.Channel)
    commit(SET_CAMERA_POSITION_TYPES, payload.CameraPositionType)
    commit(SET_DEVICE_HEALTH_CHECK_TYPES, payload.DeviceHealthCheckType)
    commit(SET_VIDEO_STREAM_QUALITY_TYPES, payload.VideoStreamQualityType)
    commit(SET_SPEED_UNIT_TYPES, payload.SpeedUnitType)
    commit(SET_LANGUAGES, payload.Language)
    commit(SET_LICENSES, payload.License)
    commit(SET_ROLES, payload.Role)
    commit(SET_FUEL_TYPES, payload.FuelType)
    commit(SET_VEHICLE_TYPES, payload.VehicleType)
    commit(SET_EVENT_TYPES, payload.EventType)
    commit(SET_EVENT_CATEGORIES, payload.EventCategory)
    commit(SET_EVENT_CLASSIFICATIONS, payload.EventClassification)
    commit(SET_THRESHOLD_LEVELS, payload.ThresholdLevel)
    commit(SET_ALARM_PIPELINE, payload.AlarmPipeline)
    commit(SET_TIMELINE_BLOCK_STATUSES, payload.TimelineBlockStatus)
    commit(SET_TIME_ZONES, payload.TimeZones)
    commit(SET_BRAND_IMAGE_TYPE, payload.BrandImageType)
};

export default {
    setDictionaries,
};
